import { createSvgIcon } from './_base';

export const CheckIcon = createSvgIcon(
  '0 0 24 24',
  <path d="M20.5304 6.46967C20.8233 6.76256 20.8233 7.23744 20.5304 7.53033L9.53043 18.5303C9.23754 18.8232 8.76267 18.8232 8.46978 18.5303L3.46968 13.5303C3.17678 13.2374 3.17677 12.7626 3.46966 12.4697C3.76255 12.1768 4.23742 12.1768 4.53032 12.4697L9.00009 16.9393L19.4697 6.46967C19.7626 6.17678 20.2375 6.17678 20.5304 6.46967Z" />
);
